export default "__VITE_ASSET__b91f1b28__"